// extracted by mini-css-extract-plugin
export default {"root":"SecretCode_root__hmduZ"};